/**
 * Versioni
 * 1001 2022/04/23  registrazione icone
 */

import {
  LitElement,
  html,
  TemplateResult,
  css,
  SVGTemplateResult, svg
} from 'lit';
import { customElement, property } from 'lit/decorators';
import {classMap} from 'lit/directives/class-map';
import { ref } from 'lit/directives/ref';
import {unsafeSVG} from 'lit/directives/unsafe-svg';
import { commonStyles } from '../../styles';


/**
 * @customElement 'k-icon'
 */
@customElement('k-icon')
export class KelydraIcon extends LitElement {

  private static templates:{[name:string]:SVGTemplateResult} = {};

  static registerSvgTemplate(name:string, svg:SVGTemplateResult) {
    KelydraIcon.templates[name] = svg;
  }

  static registerSvgString(name:string, s:string) {
    KelydraIcon.templates[name] = svg`${unsafeSVG(s)}`;
  }

  static get names():string[] {
    return Object.keys(KelydraIcon.templates);
  }

  static styles = [
    commonStyles,
    css`

    :host {
      display: inline-block;
      width: var(--icon-size, 24px);
      height: var(--icon-size, 24px);
    }

    :host([button]) {
      display: inline-block;
      width: var(--icon-button-size, var(--icon-size, 40px));
      height: var(--icon-button-size, var(--icon-size, 40px));
    }
      

    .container {
      fill: var(--icon-color, black);
      width: var(--icon-size, 24px);
      height: var(--icon-size, 24px);
      transform:rotate(var(--icon-rotate,0));
    }

    .container.button {
      cursor: pointer;
      padding: var(--icon-button-padding, 8px);
    }  

    .container.button.disabled {
      cursor: initial;
      fill:lightgray;
    }
    
  `
  ];


  @property()
  name:string;

  @property()
  color:string;

  @property()
  rotate:string;

  @property()
  size:string;

  @property({type:Boolean})
  button:boolean;

  @property({type:Boolean})
  disabled:boolean;

  renderSvg():SVGTemplateResult {
    if (KelydraIcon.templates[this.name]) {
      return KelydraIcon.templates[this.name];
    }
    return svg`<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.90039 8.07954C7.90039 3.30678 15.4004 3.30682 15.4004 8.07955C15.4004 11.4886 11.9913 10.8067 11.9913 14.8976" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 19.01L12.01 18.9989" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
  }

  decorateContainer(divElement:Element) {
    if (divElement) {
      if (this.color) {
        (<HTMLDivElement>divElement).style.setProperty('--icon-color',this.color);
      }
      if (this.rotate) {
        (<HTMLDivElement>divElement).style.setProperty('--icon-rotate',this.rotate + 'deg');
      }
      if (this.size) {
        (<HTMLDivElement>divElement).style.setProperty('--icon-size',this.size);
      }
    }
  }

  render(): TemplateResult {
    return html`
        <div class="container ${classMap({ripple:this.button && !this.disabled, button:this.button, disabled:this.disabled})}" ${ref(this.decorateContainer)} >
            ${this.renderSvg()}
        </div>
    `;
  }
}
